var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('topIndex'),_c('navbar'),_c('swiperp'),_c('navTab'),_c('stellar'),_c('swiperTab'),_c('cardTab'),_c('footerIndex')],1)}
var staticRenderFns = []

export { render, staticRenderFns }